import React, { useContext } from "react";
import PropTypes from "prop-types";
import MessageContainer from "../MessageContainer";
import { ReactComponent as DocumentSvg } from "../../../../assets/chat/nda-document.svg";
import Button from "../../Button";
import AppContext from "../../../../AppContext";
import { useNavigate } from "react-router-dom";

const _prefix = "chat-tendering__sign-contract";

const SignContract = ({ tenderingId }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate(`/tenderings/${tenderingId}/contract/contractor`);
  };

  return (
    <MessageContainer alignment={"center"}>
      <div className={_prefix}>
        <div className={`${_prefix}__desc`}>
          <DocumentSvg width={24} />
          <span className={`${_prefix}__desc__text`}>
            Please check and sign the contract before start our project
          </span>
        </div>
        <Button label={"View Contract"} size="small" onClick={handleClick} />
      </div>
    </MessageContainer>
  );
};

SignContract.propTypes = {};

export default SignContract;
